import { createAuditRoutes } from "@template/modules/auditRoutes";

export const protectedRoutes = createAuditRoutes({
  meta: {
    title: "audit.title",
    breadcrumb: ["menu.section_system", "menu.audit"],
    requiresAuth: true,
    requiresAdmin: true,
  },
});
